export default "__VITE_ASSET__DML4yvL9__"